import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import Roboto from '../../core/fonts/Roboto-Regular-normal.js';
import RobotoBold from '../../core/fonts/Roboto-Bold-bold.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as moment from "moment";

@Injectable()
export class LetterService {


    constructor(private translateService: TranslateService,
    ) {

    }

    getLetter(partner, account, letter, date) {

        var img = new Image();
        img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAA+CAMAAADQ1TPBAAAAdVBMVEUAAAAwsFAwtE8xtE4AAAAAAAAws1AAAAAwtE4AAAAws04wsk0AAAAws04AAAAAAAAAAAAAAAAwr1AAAAAxs04xtE4ws00wtVAAAAAxs04ws04AAAAxs08ys04wtE0AAAAwslAAAAAwr0Aws04AAAAxs04AAAD8TZIMAAAAJXRSTlMAIJ/fQKBAIN+/v2DfgGBw75AQEO/PUDAwsJCA75Bwz2BQENCwmluwwAAAAsRJREFUWMPtl42OojAQgAeqcBYQ5B911d3bmfd/xKu0MLAIWUnEXMIXg+1QnI9OUxAe4HyIFFPpWfAmLIkG4cFbsAQippnMUPEBi8IGwqlbxzc5VIh/Y9AUZ0QHlsZBFHG3J2FpbMQbMPIN03DGFDrkiBdYlvjHzFuItqmJLT9yeCWcshoo8F6RWfBSOKVp59wXqMlgwCsVBAZN36v3ikKJePBKWIGbpi8RLR2SMGAZBYGpmRgBA5ZSEKvCqrCMQnypN983KlgC78iv5RXYQCP7CjHicSEFG7FyCnVEp6cAN9taSCFDYUzsjgJXIwuC4DyiUG5a2pALmqQNtSeTT2A6ccTAvJzIRwqaxwp7Yg5QExLpH3YjCs2o9qRPJ2AORLuegjNUiOsHlOb4S4Ut0V7fItG2CRktt81peio+rfAXPVARDYwWwidSxxImFa6s0PM/TCpwkzk/eGdRCsCMKFA4UNiRv6PoWYUCsZqlEFGU9BTqzqFZOKwgguA4qSARb7MUTurTKHAdNq4ewwo1EwqxVJYwS2GzI3L7Clfy78WIElYo0BCAIagsgNxukKhwZiqUKntPQU/ASVeiSWp5NT+SYJfUg5kKcFCHRoH3j42KGIVRrK7A0YLZCklE166CT9FGoddpNvZWHBe1gnQ0RQwwW6G+7QMrlNQSAgRj/1wFXvpr8imFT5WSFfQ4VthSjQnFZxTFyAvUswr6ZpskYU9hwwr1RaV7JyJKAC6IWAWeIf+ar2AShebb7SnAjhXMMmTTALscuRC3pxR4iqOr3+7/rOC2Clwu2JuYJZGxO8txUoH3euiQ6DKzAT+/w3aFflPkmuF+c3nseDWXXspfKbinEnqUp+/dNtxwYN+0P8PEXBO67eU8klMO+q9mVVgVVoVVYVVYFVaFVeF/UsjFHcRUtHC/+oIFqHAKBxYgz/6MI+GF/AMi2YXLRwOzUAAAAABJRU5ErkJggg=="

        let doc = new jsPDF('p', 'px', 'a4');

        doc.addFileToVFS('Roboto-Regular.ttf', Roboto); //446.46
        doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold); //631.4175

        var positionx = 40;
        var positiony = 40;

        // HEADER
        doc.setDrawColor(49, 179, 78); // draw lines
        doc.setLineCap("round");
        doc.setLineWidth(5);
        doc.line(positionx, positiony, positionx, positiony + 20);

        doc.setFont("Roboto", "normal");
        doc.setFontSize(16);
        doc.text(this.translateService.instant('settings.letter.pdf.title'), positionx + 10, positiony + 12.5);

        positiony = positiony + 50;

        //CONTENT

        //para
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.to'), positionx, positiony);

        const labelTo = doc.getTextWidth(this.translateService.instant('settings.letter.pdf.to'));

        doc.setFont("Roboto-Bold", "bold");
        doc.text(partner, positionx + labelTo, positiony);

        positiony = positiony + 10;

        //name
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(letter?.partner_name ? letter?.partner_name : "", positionx, positiony);

        positiony = positiony + 10;

        //cnpj
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.CNPJ'), positionx, positiony);

        const labelCnpj = doc.getTextWidth(this.translateService.instant('settings.letter.pdf.CNPJ'));
        doc.text(letter?.partner_document ? letter?.partner_document : "", positionx + labelCnpj, positiony);

        positiony = positiony + 20;

        //text
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.text'), positionx, positiony);

        positiony = positiony + 10;

        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.text1', { date: moment(date).format("DD/MM/yyyy") }), positionx, positiony);

        positiony = positiony + 10;

        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.text2'), positionx, positiony);

        positiony = positiony + 20;

        doc.setDrawColor(153, 153, 153); // Cor preta
        doc.setFillColor(255, 255, 255); // Cor de preenchimento branco
        doc.setLineWidth(0.5);

        // Desenha o retângulo (x, y, largura, altura)
        const rectangleWidth = 350; // espaço extra para separar o label do valor
        const rectangleHeight = 60; // altura fixa para o retângulo

        // Desenhando o retângulo (x, y, largura, altura)
        doc.rect(positionx, positiony, rectangleWidth, rectangleHeight);

        positiony = positiony + 18;

        //Saldo transito
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.in_transit'), positionx + 20, positiony);

        const labelTransit = doc.getTextWidth(this.translateService.instant('settings.letter.pdf.in_transit'));

        doc.setFont("Roboto-Bold", "bold");
        doc.text("R$ " + (letter?.r_in_transit_amount ? new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(letter.r_in_transit_amount) : "0"), positionx + 20 + labelTransit, positiony);

        positiony = positiony + 15;

        //Saldo pendente
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.pending'), positionx + 20, positiony);

        const labelPending = doc.getTextWidth(this.translateService.instant('settings.letter.pdf.pending'));

        doc.setFont("Roboto-Bold", "bold");
        doc.text("R$ " + (letter?.r_pending_amount ?
            new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(letter.r_pending_amount) : "0"), positionx + 20 + labelPending, positiony);

        positiony = positiony + 15;

        //Saldo disponivel
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.available'), positionx + 20, positiony);

        const labelAvaiable = doc.getTextWidth(this.translateService.instant('settings.letter.pdf.available'));

        doc.setFont("Roboto-Bold", "bold");
        doc.text("R$ " + (letter?.r_available_amount ?
            new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(letter.r_available_amount) : "0"), positionx + 20 + labelAvaiable, positiony);

        positiony = positiony + 35;

        //att
        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text(this.translateService.instant('settings.letter.pdf.att'), positionx, positiony);

        positiony = positiony + 20;



        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(8);
        doc.text("Os valores apresentados são líquidos de taxa de comissão.", positionx, positiony);

        positiony = positiony + 10;


        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(8);
        doc.text("Saldo em trânsito se refere às vendas aguardando confirmação de entrega.", positionx, positiony);

        positiony = positiony + 10;


        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(8);
        doc.text("Saldo pendente se refere às operações agendadas para repasse em data futura, de acordo com condição de pagamento contratada.", positionx, positiony);

        positiony = positiony + 10;

        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(8);
        doc.text("Saldo disponível se refere às operações agendadas com repasse em data passada, disponíveis para saque.", positionx, positiony);

        positiony = positiony + 10;

        //FOOTER
        positiony = positiony + 10;


        doc.addImage(img.src, 'png', (doc.internal.pageSize.width / 2) - 30, positiony, 55, 26, null, 'SLOW');

        positiony = positiony + 40;

        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(10);
        doc.text('© Tuna Pagamentos Ltda. CNPJ: 43.098.655/0001-57', doc.internal.pageSize.width / 2, positiony, null, 'center');

        positiony = positiony + 15;


        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(11);
        doc.text("Rodovia Admar Gonzaga, 440 - Itacorubi, Florianopolis - SC, 88.034-001.", doc.internal.pageSize.width / 2, positiony, null, 'center');

        positiony = positiony + 15;

        doc.setTextColor("#666666");
        doc.setFont("Roboto", "normal");
        doc.setFontSize(10);
        doc.text(this.translateService.instant('transactions.receipt.generate') + moment().format("DD/MM/yyyy") +
            this.translateService.instant('transactions.receipt.as') + moment().format("HH:mm:ss"), doc.internal.pageSize.width / 2, positiony, null, 'center');

        doc.save(partner + "-" + moment(date).format("yyyy-MM-DD") + "-carta-circularizacao" + '.pdf');


    }
}